import { createFileRoute, redirect } from "@tanstack/react-router";

/** Government portal is scoped to the signed-in user's jurisdiction; there is no jurisdictions list. */
export const Route = createFileRoute("/government/jurisdictions")({
  beforeLoad: () => {
    throw redirect({ to: "/government/overview", replace: true });
  },
  component: () => null,
});
